
export default {
  data() {
    return {
      showText: false
    }
  }
}
